import React, { useState, useEffect } from "react";
import { DataTable } from "../../components/tables/index";
import { ConversionsDataGridCols } from "./data-grid-cols";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../app/service/admin.service";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
import { Header } from "../../components/user-dashboard/header";
import { Sidebar } from "../../components/user-dashboard/sidebar";

const ConversionList = () => {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [usersData, setUsersData] = useState<any>([]);
  const navigate = useNavigate();

  const handleCancel = () => {
    setName("");
    // setFilteredUsers(usersData);
    getUsers();
    setDate("");
  };

  const handleSearch = () => {
    if (date) {
      const filteredData = usersData?.filter((item: any) => {
        console.log("Original createdAt:", item.createdAt); // Log original createdAt

        const formattedDate = moment(
          item.createdAt,
          "DD MMM YYYY, hh:mm A"
        ).format("YYYY-MM-DD");
        console.log("Formatted createdAt:", formattedDate); // Log formatted date

        console.log("Comparing with date:", date); // Log selected date

        return date ? formattedDate === date : true;
      });

      setUsersData(filteredData);
    } else {
      const decodedSearchTerm = decodeURIComponent(name.trim());

      const data = {
        search: decodedSearchTerm,
        start: 1,
        count: 10,
      };

      AdminService.getConversionList(data).then((res: any) => {
        if (res.status === "Success") {
          const formattedData = res?.data?.result.map((item: any) => ({
            ...item,
            createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
          }));

          setUsersData(formattedData);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleBdiAccess = (data: any) => {
    const userdata: any = sessionStorage.getItem("loginData");
    const userRole = JSON.parse(userdata);
    const payloadData = {
      isVerify: true,
      accessByBdi: userRole.email,
      cEmail: data.email,
    };
    AdminService.updateConversionList(payloadData).then((res: any) => {
      if (res.status === "Success") {
      } else {
        toast.error(res.message);
      }
    });
  };

  const getUsers = () => {
    const userdata: any = sessionStorage.getItem("loginData");
    const userRole = JSON.parse(userdata);
    const payloadData = {
      isVerify: true,
      accessByBdi: userRole.email,
    };
    AdminService.getConversions(payloadData).then((res: any) => {
      if (res.status === "Success") {
        const formattedData = res?.data?.map((item: any) => ({
          ...item,
          createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
        }));

        setUsersData(formattedData);
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 mt-3">
            <label className="form-label d-flex justify-content-start text-start">
              <b> Conversion List</b>
            </label>
            <div className="d-flex">
              <input
                name="User Name"
                onChange={(e: any) => setName(e.target.value)}
                className="form-control mt-1 me-2"
                value={name}
                placeholder="Enter the EmailId / Phone No"
              />
              <input
                type="date"
                name="Date"
                onChange={(e: any) => setDate(e.target.value)}
                className="form-control mt-1 me-2"
                value={date}
              />
              <button
                className="btn btn-primary rounded px-4 py-1"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btn btn-secondary rounded ms-2 px-4 py-1"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
         
          <div className="mt-5">
            <DataTable
              tableData={usersData}
              TableCols={ConversionsDataGridCols}
              handleBdiAccess={handleBdiAccess}
            />
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionList;
